const ITEMS = [
  { label: "CUSTOM WEB APPLICATIONS", bold: true },
  { label: "AI APPS, COPILOTS & AUTOMATION", accent: true },
  { label: "CLOUD MIGRATION & MANAGEMENT" },
  { label: "DOCKER & KUBERNETES" },
  { label: "DEDICATED SERVERS & VMS" },
  { label: "DISASTER RECOVERY & ONGOING SUPPORT" },
];

function Row() {
  return (
    <div className="flex items-center gap-12">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center gap-12">
          <span
            className={
              item.bold
                ? "text-white font-bold"
                : item.accent
                  ? "text-royal-bright"
                  : ""
            }
          >
            {item.label}
          </span>
          <span aria-hidden="true">//</span>
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div
      data-testid="services-marquee"
      aria-hidden="true"
      className="py-4 bg-steel text-white border-y border-slate-700 overflow-hidden"
    >
      <div className="mq-banner font-mono-sub text-xs tracking-widest uppercase flex items-center gap-12 text-slate-400">
        <Row />
        <Row />
      </div>
    </div>
  );
}
